import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

//Set the styles
const useStyles = makeStyles(() => ({
  pmiNotFoundContainer: {
    color: '#d6012e',
  },
  h1: {
    fontSize: '10rem',
  },
  p: {
    fontSize: '1.2rem',
    color: '#23856c',
  },
}));

export const NotFound = (): ReactElement => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        'pmi-h-100 pmi-d-flex pmi-flex-column pmi-align-items-center pmi-justify-content-center',
        classes.pmiNotFoundContainer
      )}
    >
      <h1 className={classes.h1}>404</h1>
      <p className={classNames('pmi-mb-1', classes.p)}>
        La pagina che stai cercando non è stata trovata.
      </p>
      <Link to="/">Torna alla pagina iniziale!</Link>
    </div>
  );
};

NotFound.displayName = 'Not Found Error component';
